
import { isEqual } from 'lodash';

export const checkDuplicateContact = (NewContactsObj, OriginalContactsAray) => {
	let duplicateIndex = -1;
	OriginalContactsAray.forEach((row, index) => {

		// check email Duplication
		if(NewContactsObj.emailId && row.emailId) {
			if(NewContactsObj.emailId == row.emailId ) {
				duplicateIndex = index;
			}
		}

		// check Phone No Duplication
		if(NewContactsObj.phoneNo && row.phone) {
			if(NewContactsObj.phoneNo == row.phone.phoneNo && NewContactsObj.countryCode == row.phone.countryCode ) {
					duplicateIndex = index;
			}
		}

		// check Fax Duplication
		if(NewContactsObj.fax && row.fax) {
			if(NewContactsObj.fax == row.fax.phoneNo && (NewContactsObj.countryCode ? NewContactsObj.countryCode : NewContactsObj.faxCountryCode) == row.fax.countryCode) {
				duplicateIndex = index;
			}
		}

	});

	return duplicateIndex;
}
